

$(document).ready(function () {



  function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

   if ( $("#block10 .result").length ) {
     var check = $('body').is('#professionals');
     
        var antiaging = [
        { id: 1, title: 'Used Celluma 3 times a week for 4 weeks', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/anti-aging-2.jpg?v=167175508452562185281727929321' alt='Anti-Aging Before/After'/>" },
        { id: 2, title: 'Used Celluma 2 times a week 4 weeks later', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/anti-aging-3.jpg?v=7084659041379966381727929321' alt='Anti-Aging Before/After'/>" },
        { id: 3, title: 'Used Celluma 2 times a week 4 weeks later', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/anti-aging-4-1.jpg?v=176855830871425718321727929322' alt='Anti-Aging Before/After'/>" },
        { id: 4, title: '9 treatments total over 4.5 weeks', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/anti-aging-6-1.jpg?v=99350872223749413831727929324' alt='Anti-Aging Before/After'/>" } 
        ];
         
        /*var pain = [
        { id: 1, title: 'Bruise after one 30 minute Celluma treatment', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/wound-healing-1.jpg?v=80400736280224865051727929642' alt='Wound Healing Before/After'>" },
        { id: 2, title: 'Bruise after one 30 minute Celluma treatment', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/wound-healing-2.jpg?v=104991338983246439171727929642' alt='Wound Healing Before/After'>" }
        ];*/
         
        var acne = [
        { id: 1, title: 'Used Celluma 2 times a week 5 weeks later', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/acne-treatment-2.jpg?v=103434563122230720091727929310' alt='Acne Treatment Before/After'>" },
        { id: 2, title: 'Used Celluma 2 times a week 8 weeks later', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/acne-treatment-3.jpg?v=111370731491268549031727929311' alt='Acne Treatment Before/After'>" },
        { id: 3, title: 'Used Celluma 2 times a week 2 weeks later', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/acne-treatment-4.jpg?v=36461082957880021161727929311' alt='Acne Treatment Before/After'>" },
        { id: 4, title: 'Used Celluma 2 times a week 9 weeks later', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/acne-treatment-5.jpg?v=27592315407246308731727929312' alt='Acne Treatment Before/After'>" }
        ];
         
       /* var wound = [
        { id: 1, title: 'Bruise after one 30 minute Celluma treatment', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/wound-healing-2.jpg?v=104991338983246439171727929642' alt='Wound Healing Before/After'>" },
        { id: 2, title: 'Arm bruise 20 hours after 1 Celluma treatment', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/wound-healing-3.jpg?v=22391669930912525981727929643' alt='Wound Healing Before/After'>" }
        ];*/
        
        if(check){
        	var wound = [
    	    { id: 1, title: 'Arm bruise 20 hours after 1 Celluma treatment', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/wound-healing-3.jpg?v=22391669930912525981727929643' alt='Wound Healing Before/After'>" }
        	];
        	var pain = [];
        }else{
	        var wound = [
    	    { id: 1, title: 'Bruise after one 30 minute Celluma treatment', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/wound-healing-2.jpg?v=104991338983246439171727929642' alt='Wound Healing Before/After'>" },
        	{ id: 2, title: 'Arm bruise 20 hours after 1 Celluma treatment', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/wound-healing-3.jpg?v=22391669930912525981727929643' alt='Wound Healing Before/After'>" }
        	];
        	var pain = [
        	{ id: 1, title: 'Bruise after one 30 minute Celluma treatment', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/wound-healing-1.jpg?v=80400736280224865051727929642' alt='Wound Healing Before/After'>" },
        	{ id: 2, title: 'Bruise after one 30 minute Celluma treatment', image: "<img src='//celluma-eu.myshopify.com/cdn/shop/t/19/assets/wound-healing-2.jpg?v=104991338983246439171727929642' alt='Wound Healing Before/After'>" }
        	];
          }

         
         $(document).on('click','#block10 .result .btn2', function(){ 
				
         
         	
         
         
                    antiaging = shuffle(antiaging);

                    var a=1; 
                    $(antiaging).each(function(i, obj) {
                     if (a == 1) {
                         var item='<div class="item flex"><div class="left">'+obj.image+'</div><div class="right"><p>'+obj.title+'</p></div></div>';
                         $(item).insertBefore( $('#block10 .result .btn2') );

                        idToRemove = obj.id;
                        antiaging = antiaging.filter(function(item) {
                          return item.id != idToRemove;
                        });

                        a++;
                     }
                     });

           if(pain.length > 0){
                     pain = shuffle(pain);

                    var a=1; 
                    $(pain).each(function(i, obj) {
                     if (a == 1) {
                         var item='<div class="item flex"><div class="left">'+obj.image+'</div><div class="right"><p>'+obj.title+'</p></div></div>';
          				
                         $(item).insertBefore( $('#block10 .result .btn2') );

                        idToRemove = obj.id;
                        pain = pain.filter(function(item) {
                          return item.id != idToRemove;
                        });
                        a++;
                     }
                     });
           }


                      acne = shuffle(acne);

                    var a=1; 
                    $(acne).each(function(i, obj) {
                     if (a == 1) {
                         var item='<div class="item flex"><div class="left">'+obj.image+'</div><div class="right"><p>'+obj.title+'</p></div></div>';
                         $(item).insertBefore( $('#block10 .result .btn2') );
                        idToRemove = obj.id;
                        acne = acne.filter(function(item) {
                          return item.id != idToRemove;
                        });
                        a++;
                     }
                     });


                     wound = shuffle(wound);

                    var a=1; 
                    $(wound).each(function(i, obj) {
                     if (a == 1) {
                         var item='<div class="item flex"><div class="left">'+obj.image+'</div><div class="right"><p>'+obj.title+'</p></div></div>';
                         $(item).insertBefore( $('#block10 .result .btn2') );
                        idToRemove = obj.id;
                        wound = wound.filter(function(item) {
                          return item.id != idToRemove;
                        });
                        a++;
                     }
                     });
          
          
          		if (antiaging.length === 0 && pain.length === 0 && acne.length === 0 && wound.length === 0) {  $('#block10 .result .btn2').fadeOut(); }
          
          });

      
      }
   
   
   
   
});





window.gred = window.gred || {};
gred.init = function () {
    gred.showPopup();
    gred.hidePopup();
    gred.btnAddtocart();
    gred.quickView();
    gred.checkItemsInMiniCart();
    gred.removeItemsInMiniCart();
    gred.updatePricing();

    gred.hideDropdown();
    gred.initAddToCart();

    gred.initWishlist();
    gred.initProductWishlist();
    gred.initRemoveWishlist();
    gred.toggleMenu();
};


jQuery(document).ready(function () {
    "use strict";

    /*
    $('.toggle-menu .active').closest('.toggle-content').addClass('active');
  */

    var hH = $('.header--fixed').outerHeight();
    $('.header-vsb').css("height", hH);

    /* Currency */
    $('.currency-Picker .dropdown-content a').on('click', function () {
        $("select.currency-picker").val($(this).data('value')).change();
        $(this).closest('.dropdown-content').removeClass('active');
    });

    /* Memamenu */
    $(".width-full").each(function () {
        $(this).closest('.megamenu').addClass('full-width');

    });

    /* Countdown */
    $('.countdown ul').each(function () {
        var endDate = $(this).data('date');
        $(this).countdown({
            date: endDate,
            render: function (data) {
                $(this.el).html(
                    '<li><span>' + this.leadingZeros(data.days, 2) + '</span> Days</li>'
                    + '<li><span>' + this.leadingZeros(data.hours, 2) + '</span>Hours</li>'
                    + '<li><span>' + this.leadingZeros(data.min, 2) + '</span>Mins</li>'
                    + '<li><span>' + this.leadingZeros(data.sec, 2) + '</span>Secs</li>'
                );
            }
        });
    });

    /* Back to top */
    if ($('.back-to-top').length) {
        var scrollTrigger = 100, // px
            backToTop = function () {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > scrollTrigger) {
                    $('.back-to-top').addClass('show');
                } else {
                    $('.back-to-top').removeClass('show');
                }
            };
        backToTop();
        $(window).on('scroll', function () {
            backToTop();
        });
        $('.back-to-top').on('click', function (e) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
})


$(document).on('click', '.overlay, .close-popup', function () {
    gred.hidePopup('.gred-popup');
    setTimeout(function () {
        $('.loading').removeClass('loaded-content');
    }, 500);
    return false;
})


$(document).on('click touchstart', function (e) {
    var dropdown = $(".mini-cart.click.active");
    if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
        dropdown.removeClass('active');
    }
});

jQuery('body').keydown(function (e) {
    if (e.which == 27) {
        gred.hidePopup('.gred-popup');
        jQuery('body').unbind('keydown');
    }
});

$(".swiper-container").each(function () {

    var xs_item = $(this).attr('data-xs-items');
    var datarow = $(this).attr('data-row');


    if (typeof xs_item !== typeof undefined && xs_item !== false) {
    } else {
        xs_item = 1;
    }

    if (typeof datarow !== typeof undefined && datarow !== false) {
    } else {
        datarow = 1;
    }

    var config = {
        spaceBetween: '8',
        slidesPerView: $(this).data('items'),
        direction: $(this).data('direction'),
        slidesPerColumn: datarow,
        paginationClickable: true,
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {

            320: {
                slidesPerView: xs_item,
                spaceBetweenSlides: 0
            },

            480: {
                slidesPerView: xs_item,
                spaceBetweenSlides: 0
            },

            640: {
                slidesPerView: xs_item,
                spaceBetweenSlides: 0
            },

            980: {
                slidesPerView: 3,
                spaceBetweenSlides: 0
            }
        }
    };
    var swiper = new Swiper(this, config);
});


/********************************************************
 # MINICART
 ********************************************************/
$('.mini-cart.click > a').click(function (event) {
    event.preventDefault();
    $(this).parent().toggleClass("active");
});




jQuery(document).ready(function () {

    gred.quantity();
    $('.close-noitice').click(function (e) {
        e.preventDefault();
        $(this).parent().animate({right: '-300px'}, 500);
    })


    $('.dropdown-toggle > a').click(function () {
        $('.mini-cart-default').removeClass('active');
        if ($(this).closest('.dropdown-toggle').find('.dropdown-content').hasClass('active')) {
            $('.dropdown-content').removeClass('active');
        } else {
            $('.dropdown-content').removeClass('active');
            $(this).closest('.dropdown-toggle').find('.dropdown-content').addClass('active');
        }
        return false;
    });


    /* Tabs */
    $(".e-tabs").each(function () {
        $(this).find('.tabs-title li:first-child').addClass('current');
        $(this).find('.tab-content').first().addClass('current');

        $(this).find('.tabs-title li').click(function () {

            $(".tab-content").show();

            var tab_id = $(this).attr('data-tab');

            var url = $(this).attr('data-url');
            $(this).closest('.e-tabs').find('.tab-viewall').attr('href', url);

            $(this).closest('.e-tabs').find('.tabs-title li').removeClass('current');
            $(this).closest('.e-tabs').find('.tab-content').removeClass('current');

            $(this).addClass('current');
            $(this).closest('.e-tabs').find("#" + tab_id).addClass('current');

            $(".tab_drawer_heading").removeClass("d_active");

            $(".tab_drawer_heading[rel^='" + tab_id + "']").addClass("d_active");


        });


        $(".tab_drawer_heading").click(function () {

            $(".tab-content").hide();
            $(".tab-content").removeClass('current');
            var d_activeTab = $(this).attr("rel");
            $("#" + d_activeTab + '.tab-content').fadeIn();
            $("#" + d_activeTab + '.tab-content').addClass('current');


            $(".tab_drawer_heading").removeClass("d_active");
            $(this).addClass("d_active");

            $("ul.tabs li").removeClass("current");
            $("ul.tabs li[data-tab^='" + d_activeTab + "']").addClass("current");
        });


    });


});


/********************************************************
 # toggle-menu
 ********************************************************/


gred.toggleMenu = function () {

    $('.toggle-menu .caret').click(function () {
        $(this).closest('.toggle-content').find('.sub-menu').slideToggle("fast");

        if ($(this).closest('.toggle-content').hasClass('open')) {

            $(this).closest('.toggle-content').removeClass('open');
            $(this).closest('.toggle-content').addClass('closed');

            $(this).html('<i class="fa fa-angle-down"></i>');

        } else {
            $(this).html('<i class="fa fa-angle-up"></i>');

            $(this).closest('.toggle-content').addClass('open');
            $(this).closest('.toggle-content').RemoveClass('closed');

        }


        return false;
    });

}


/********************************************************
 # QUANTITY
 ********************************************************/
gred.hideDropdown = function () {
    $(document).on('click touchstart', function (e) {
        var dropdown = $(".dropdown-content");
        if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
            dropdown.removeClass('active');
        }
    });
}

gred.quantity = function () {
    $('.qtyplus').click(function (e) {
        e.preventDefault();
        fieldName = $(this).attr('data-field');
        var currentVal = parseInt($('input[data-field=' + fieldName + ']').val());
        if (!isNaN(currentVal)) {
            $('input[data-field=' + fieldName + ']').val(currentVal + 1);
        } else {
            $('input[data-field=' + fieldName + ']').val(0);
        }


        gred.updatePricing();


    })

    $(".qtyminus").click(function (e) {
        e.preventDefault();
        fieldName = $(this).attr('data-field');
        var currentVal = parseInt($('input[data-field=' + fieldName + ']').val());
        if (!isNaN(currentVal) && currentVal > 1) {
            $('input[data-field=' + fieldName + ']').val(currentVal - 1);
        } else {
            $('input[data-field=' + fieldName + ']').val(1);
        }
        gred.updatePricing();
    })

    $('#Quantity').on('change', function () {
        gred.updatePricing();
    })
}


/********************************************************
 # SHOW NOITICE
 ********************************************************/
gred.showNoitice = function (selector) {
    $(selector).animate({right: '0'}, 500);
    setTimeout(function () {
        $(selector).animate({right: '-300px'}, 500);
    }, 3500);
};


/********************************************************
 # SHOW LOADING
 ********************************************************/
gred.showLoading = function (selector) {
    var loading = $('.loader').html();
    $(selector).addClass("loading").append(loading);
}

/********************************************************
 # HIDE LOADING
 ********************************************************/
gred.hideLoading = function (selector) {
    $(selector).removeClass("loading");
    $(selector + ' .loading-icon').remove();
}


/********************************************************
 # SHOW POPUP
 ********************************************************/
gred.showPopup = function (selector) {
    $(selector).addClass('active');
};

/********************************************************
 # HIDE POPUP
 ********************************************************/
gred.hidePopup = function (selector) {
    $(selector).removeClass('active');
}

/********************************************************
 # CONVERTTOSLUG
 ********************************************************/
gred.convertToSlug = function (text) {
    return text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
}


/********************************************************
 # UPDATEPRICING
 ********************************************************/
gred.updatePricing = function () {

    var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    var unitPriceTextMatch = jQuery('.product-single .product-single-prices .money').text().match(regex);

    if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = jQuery('.product-single .product-single-prices .money').text().match(regex);
    }

    if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g, '');
        var quantity = parseInt(jQuery('#Quantity').val());
        var totalPrice = unitPrice * quantity;

        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
        if (!totalPriceText.match(regex)) {
            regex = /([0-9]+[.|,][0-9]+)/g;
        }
        totalPriceText = totalPriceText.match(regex)[0];

        var regInput = new RegExp(unitPriceText, "g");
        var totalPriceHtml = jQuery('.product-single .money').html().replace(regInput, totalPriceText);

        $('.total-price .money').html(totalPriceHtml);

    }


}


/********************************************************
 # QUICKVIEW - ADDTOCART
 ********************************************************/
gred.quickviewAddToCart = function () {
    if ($('.quickview-product .btn-addToCart').length > 0) {
        $('.quickview-product .btn-addToCart').click(function () {
            var variant_id = $('.quickview-product select[name=id]').val();
            if (!variant_id) {
                variant_id = $('.quickview-product input[name=id]').val();
            }
            var quantity = $('.quickview-product input[name=quantity]').val();
            if (!quantity) {
                quantity = 1;
            }

            var title = $('.quickview-product .product-name a').html();
            var image = $('.quickview-product .featured-image img').attr('src');

            gred.doAjaxAddToCart(variant_id, quantity, title, image);
        });
    }
}


/********************************************************
 # PRODUCT DETAIL - ADDTOCART
 ********************************************************/
gred.btnAddtocart = function () {
    $(window.btn_addToCart).click(function (event) {
        event.preventDefault();
        if ($(this).attr('disabled') != 'disabled') {
            var variant_id = $(window.product_detail_form + ' select[name=id]').val();
            if (!variant_id) {
                variant_id = $(window.product_detail_form + ' input[name=id]').val();
            }
            var quantity = $(window.product_detail_form + ' input[name=quantity]').val();
            if (!quantity) {
                quantity = 1;
            }
            var title = $(window.product_detail_name).html();
            var image = $(window.product_detail_mainImg).attr('src');
            gred.doAjaxAddToCart(variant_id, quantity, title, image);
        }
        return false;
    });
}

gred.productPage = function (options) {
    var moneyFormat = options.money_format,
        variant = options.variant,
        selector = options.selector,
        translations = options.translations;

    // Selectors
    var $addToCart = $('#btnAddtocart'),
        $productPrice = $('#ProductPrice'),
        $totalPrice = $('.total-price'),
        $comparePrice = $('#ComparePrice'),
        $quantityElements = $('.product-single-quantity'),
        $addToCartText = $('#btnAddtocart');

    if (variant) {
        // Select a valid variant if available
        if (variant.available) {
            // Available, enable the submit button, change text, show quantity elements
            $addToCart.removeClass('disabled').prop('disabled', false);
            $addToCartText.html(translations.add_to_cart);
            $quantityElements.removeClass('soldout');
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $addToCart.addClass('disabled').prop('disabled', true);
            $addToCartText.html(translations.sold_out);
            $quantityElements.addClass('soldout');
        }

        // Regardless of stock, update the product price
        $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));

        var variant_price = $('#Quantity').val() * variant.price;
        $totalPrice.html(Shopify.formatMoney(variant_price, moneyFormat));

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).removeClass('soldout');
        } else {
            $comparePrice.addClass('soldout');
        }

    } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        // To only show available variants, implement linked product options:
        //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
        $addToCart.addClass('disabled').prop('disabled', true);
        $addToCartText.html(translations.unavailable);
        $quantityElements.addClass('soldout');
    }
    ;

}


/********************************************************
 # ADD TO CART
 ********************************************************/
gred.initAddToCart = function () {
    $('.product-item .btn-addToCart').click(function (event) {
        event.preventDefault();
        if ($(this).attr('disabled') != 'disabled') {
            var productItem = $(this).closest('.product-item');
            var productId = $(this).closest('.product-item').attr('data-id');
            productId = productId.match(/\d+/g);

            var variant_id = $('#AddToCartForm-' + productId + ' select[name=id]').val();
            if (!variant_id) {
                variant_id = $('#AddToCartForm-' + productId + ' input[name=id]').val();
            }

            var quantity = $('#AddToCartForm-' + productId + ' input[name=quantity]').val();
            if (!quantity) {
                quantity = 1;
            }

            var title = $(productItem).find('.product-item-name').html();
            var image = $(productItem).find('.product-item-photo img').attr('src');
            gred.doAjaxAddToCart(variant_id, quantity, title, image);
        }
        return false;
    });
}

gred.doAjaxAddToCart = function (variant_id, quantity, title, image) {
    $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        beforeSend: function () {
            if (window.theme_load == "icon") {
                gred.showLoading('.btn-addToCart');
            } else {
                gred.showPopup('.loading');
            }
        },
        success: function (msg) {

            gred.hidePopup('.quickview-product');
            if (window.theme_load == "icon") {
                gred.hideLoading('.btn-addToCart');
            } else {
                $('.loading').addClass('loaded-content');
            }

            switch (window.addcart_susscess) {
                case ('popup'):
                    $('.addcart-popup').find('.product-name').html(title);
                    $('.addcart-popup').find('.product-image img').attr('src', image);

                    gred.showPopup('.addcart-popup');

                    break;
                case ('text'):
                    gred.hidePopup('.loading');
                    gred.hideLoading('.btn-addToCart');

                    break;
                case ('noitice'):
                    gred.hidePopup('.loading');
                    gred.hideLoading('.btn-addToCart');
                    $('.product-noitice.susscess').find('.product-name').html(title);
                    $('.product-noitice.susscess').find('.product-image img').attr('src', image);
                    gred.showNoitice('.product-noitice.susscess');

                    break;
                default:
                    gred.showPopup('.addcart-popup');

            }

            gred.updateMiniCart();

        },
        error: function (xhr, text) {
            gred.hidePopup('.loading');
            $('.error-message').text($.parseJSON(xhr.responseText).description);
            gred.showPopup('.error-popup');

        }
    });
}


/********************************************************
 # UPDATE MINICART
 ********************************************************/
gred.updateMiniCart = function () {
    Shopify.getCart(function (cart) {
        gred.doUpdateMiniCart(cart);
    });
}

/* DO UPDATE MINICART */
gred.doUpdateMiniCart = function (cart) {
    var template = '<li class="item clearfix" id="cart-item-{id}"><a href="{url}" title="{title}" class="product-image"><img src="{img}" alt="{title}"></a><div class="product-details"><a class="product-name" href="{url}">{title}</a><div class="custom-reviews hide-caption"><span class="shopify-product-reviews-badge" data-id="{product_id}"></span></div><span class="money">{price}</span><span class="qty">' + window.quantity + '{quantity}</span> <a href="javascript:void(0)" title="Remove This Item" class="btn-remove"> <i class="fa fa-trash-o"></i></a></div></li>';
    $('.item_count').text(cart.item_count);
    $('.cart-count').text(cart.item_count);
    $(window.cart_total).html(Shopify.formatMoney(cart.total_price, window.money_format));
    $('.miniCart-list').html('');

    if (cart.item_count > 0) {
        for (var i = 0; i < cart.items.length; i++) {
            var item = template;
            item = item.replace(/\{id\}/g, cart.items[i].id);
            item = item.replace(/\{url\}/g, cart.items[i].url);
            item = item.replace(/\{title\}/g, cart.items[i].title);
            item = item.replace(/\{quantity\}/g, cart.items[i].quantity);
            item = item.replace(/\{product_id\}/g, cart.items[i].product_id);
            item = item.replace(/\{img\}/g, Shopify.resizeImage(cart.items[i].image, 'compact'));
            item = item.replace(/\{price\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
            $('.miniCart-list').append(item);
        }
        gred.removeItemsInMiniCart();
        gred.initReview();
        gred.ConvertCurrency();
        gred.checkItemsInMiniCart();
    } else {
        $('.miniCart-content .summary').remove();
        $('.miniCart-content .miniCart-list').remove();
    }
}

/********************************************************
 # QUiCKVIEW
 ********************************************************/
gred.quickView = function () {
    $(window.btn_quickview).click(function () {
        gred.showPopup('.loading');
        var id = $(this).attr('id');
        var rating = (($(this).closest('.product-item-info').find('[id*="spr_badge"]').attr('data-rating')) * 20) + "%";
        var ratingCaption = $(this).closest('.product-item-info').find('.spr-badge-caption').text();
        var available = $(this).closest('.product-item-info').attr('data-available');
        var color_swatch = false;

        Shopify.getProduct(id, function (product) {
            var template = $('#quickview-template').html();
            $('.quickview-product').html(template);
            var quickview = $('.quickview-product');
            quickview.find('.product-name a').html(product.title).attr('href', product.url).attr('title', product.title);

            if (product.available) {
                quickview.find('.instock').addClass('active');
            } else {
                quickview.find('.outofstock').addClass('active');
            }

            if (quickview.find('.spr-badge').length > 0) {
                quickview.find('.spr-badge .spr-active').css({"width": rating});
                quickview.find('.spr-badge-caption').text(ratingCaption);
            }

            if (quickview.find('.vendor').length > 0) {
                quickview.find('.vendor span').text(product.vendor);
            }

            quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));

            if (quickview.find('.des').length > 0) {
                var description = product.description;
                quickview.find('.des').html(description);
            } else {
                quickview.find('.des').remove();
            }


            quickview.find('.products-item').attr('id', 'product-' + product.id);
            quickview.find('.variants').attr('id', 'product-actions-' + product.id);
            quickview.find('.variants select').attr('id', 'product-select-' + product.id);

            if (product.compare_at_price > product.price) {
                quickview.find('.compare-price').html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
                quickview.find('.price').addClass('on-sale');
            } else {
                quickview.find('.compare-price').html('');
                quickview.find('.price').removeClass('on-sale');
            }

            //out of stock
            if (!product.available) {
                quickview.find("select, input, .total-price, .dec, .inc, .variants label, .product-options, .product-single-quantity").remove();
                quickview.find(".btn-addToCart").text('unavailable').addClass('disabled').attr("disabled", "disabled");
            } else {
                quickview.find('.total-price span').html(Shopify.formatMoney(product.price, window.money_format));

                if (color_swatch) {
                    gred.createQuickViewVariantsSwatch(product, quickview);
                } else {
                    gred.createQuickViewVariants(product, quickview);
                }
            }

            gred.quantity();
            gred.ConvertCurrency();
            gred.quickviewAddToCart();
            gred.showPopup('.quickview-product');
            gred.loadQuickViewSlider(product, quickview);

        });
        return false;
    })
};


/* createQuickViewVariantsSwatch */
gred.createQuickViewVariantsSwatch = function (product, quickviewTemplate) {

    if (product.variants.length < 2) {
        quickviewTemplate.find('form.variants .product-options').addClass('hidden');
    }
    if (product.variants.length > 1) {
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
            quickviewTemplate.find('form.variants .product-options > select').append(option);
        }

        new Shopify.OptionSelectors("product-select-" + product.id, {
            product: product,
            onVariantSelected: selectCallbackQuickview
        });

        var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
        var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
        var options = "";

        for (var i = 0; i < product.options.length; i++) {
            options += '<div class="swatch clearfix" data-option-index="' + i + '">';
            options += '<div class="header">' + product.options[i].name + '</div>';
            var is_color = false;
            if (/Color|Colour/i.test(product.options[i].name)) {
                is_color = true;
            }
            var optionValues = new Array();
            for (var j = 0; j < product.variants.length; j++) {
                var variant = product.variants[j];
                var value = variant.options[i];
                var valueHandle = gred.convertToSlug(value);
                var forText = 'swatch-' + i + '-' + valueHandle;
                if (optionValues.indexOf(value) < 0) {
                    //not yet inserted
                    options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';

                    if (is_color) {
                        options += '<div class="tooltip">' + value + '</div>';
                    }
                    options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';

                    if (is_color) {
                        options += '<label for="' + forText + '" style="background-color: ' + valueHandle + '; background-image: url(' + filePath + valueHandle + '.png)"></label>';
                    } else {
                        options += '<label for="' + forText + '">' + value + '</label>';
                    }
                    options += '</div>';
                    if (variant.available) {
                        $('.quickview-product .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                    }
                    optionValues.push(value);
                }
            }
            options += '</div>';
        }
        quickviewTemplate.find('form.variants .product-options > select').after(options);
        quickviewTemplate.find('.swatch :radio').change(function () {
            var optionIndex = $(this).closest('.swatch').attr('data-option-index');
            var optionValue = $(this).val();
            $(this)
                .closest('form')
                .find('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');
        });

        if (product.available && product.options.size > 1) {
            Shopify.optionsMap = {};
            Shopify.linkOptionSelectors(product);
        }

    } else {
        quickviewTemplate.find('form.variants .product-options > select').remove();
        var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
        quickviewTemplate.find('form.variants .product-options').append(variant_field);
    }
};


/* createQuickViewVariants */
gred.createQuickViewVariants = function (product, quickviewTemplate) {

    if (product.variants.length < 1) {
        quickviewTemplate.find('form.variants .product-options').addClass('hidden');
    }
    if (product.variants.length > 1) {
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
            quickviewTemplate.find('form.variants .product-options > select').append(option);
        }

        new Shopify.OptionSelectors("product-select-" + product.id, {
            product: product,
            onVariantSelected: selectCallbackQuickview
        });

        quickviewTemplate.find('form.variants .selector-wrapper').each(function (i, v) {
            $(this).prepend('<div class="header">' + product.options[i].name + '</div>');
        });

        quickviewTemplate.find('form.variants .selector-wrapper label').each(function (i, v) {
            $(this).remove();
        });

    } else {
        quickviewTemplate.find('form.variants .product-options > select').remove();
        var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
        quickviewTemplate.find('form.variants .product-options').append(variant_field);
    }
}


/* QuickView VIEWMORE Slider */
gred.loadQuickViewSlider = function (product, quickviewTemplate) {
    var featuredImage = Shopify.resizeImage(product.featured_image, '1024x1024');
    quickviewTemplate.find('.featured-image').append('<a title="' + product.title + '" class="product-photo" href="' + product.url + '"><img src="' + featuredImage + '" alt="' + product.title + '"/><span class="loading" style="height: 30px; line-height: 30px; padding: 0 40px; color: #fff; background: #000; opacity: 0.4; bottom: 100px; left: 50%; z-index: 999; position: absolute; display: none;">' + window.loading_url + '</span></a>');
    if (product.images.length > 2) {
        var quickViewCarousel = quickviewTemplate.find('.more-views .swiper-wrapper');

        for (i in product.images) {
            var original = Shopify.resizeImage(product.images[i], 'original');
            var compact = Shopify.resizeImage(product.images[i], 'compact');
            var item = '<div class="swiper-slide"><a href="javascript:void(0)" data-image="' + original + '"><img src="' + compact + '"  /></a></div>';
            quickViewCarousel.append(item);
        }

        quickViewCarousel.find('a').click(function () {
            var featureImage = quickviewTemplate.find('.featured-image img');
            var moreviewLoad = quickviewTemplate.find('.featured-image .loading');
            if (featureImage.attr('src') != $(this).attr('data-image')) {
                featureImage.attr('src', $(this).attr('data-image'));
                /* moreviewLoad.show(); */
                featureImage.load(function (e) {
                    moreviewLoad.hide();
                    $(this).unbind('load');
                    moreviewLoad.hide();
                });
            }
        });

        var swiper = quickviewTemplate.find('.more-views');
        var mySwiper = new Swiper(swiper, {
            direction: 'vertical',
            slidesPerView: 4,
            spaceBetween: 10,
            paginationClickable: true,
            grabCursor: true
        })

    } else {
        quickviewTemplate.find('.more-views').remove();
    }

}

/* reConvertCurrency */
gred.reConvertCurrency = function () {
    return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
};

/* REMOVE ITEM CART */
gred.removeItemsInMiniCart = function () {
    $('.btn-remove').click(function (event) {
        event.preventDefault();
        var productId = $(this).parents('.item').attr('id');
        productId = productId.match(/\d+/g);
        Shopify.removeItem(productId, function (cart) {
            gred.doUpdateMiniCart(cart);
        });
    });
};


/* CHECK ITEM MINI CART */
gred.checkItemsInMiniCart = function () {
    if ($('.miniCart-list').children().length > 0) {
        $('.miniCart-content').removeClass('empty-cart');
    } else {
        $('.miniCart-content').addClass('empty-cart');
    }
}

/********************************************************
 # WISHLIST
 ********************************************************/

gred.initWishlist = function () {
    $('.product-item-info .add-to-wishlist').click(function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var productItem = $(this).closest('.product-item-info');

        $.ajax({
            type: 'POST',
            url: '/contact',
            data: form.serialize(),
            beforeSend: function () {
                gred.showPopup('.loading');
            },
            success: function (data) {
                form.html('');
                var title = $(productItem).find('.product-item-name').html();
                var image = $(productItem).find('.product-item-photo img').attr('src');
                $('.wishlist-popup').find('.product-name').html(title);
                $('.wishlist-popup').find('.product-image img').attr('src', image);
                gred.showPopup('.wishlist-popup');
            },
            error: function (xhr, text) {
                form.html('');
                $('.error-message').text($.parseJSON(xhr.responseText).description);
                gred.showPopup('.error-popup');
            }
        });
    });

}


gred.initProductWishlist = function () {
    $('.product-single .add-to-wishlist').click(function (e) {
        e.preventDefault();
        var form = $(this).parent();
        $.ajax({
            type: 'POST',
            url: '/contact',
            data: form.serialize(),
            beforeSend: function () {
                gred.showPopup('.loading');
            },
            success: function (data) {
                form.html('');
                var title = $('.product-info h1').html();
                var image = $('.product-single-photos img').attr('src');
                $('.wishlist-popup').find('.product-name').html(title);
                $('.wishlist-popup').find('.product-image img').attr('src', image);
                gred.showPopup('.wishlist-popup');
            },
            error: function (xhr, text) {
                gred.hidePopup('.loading');
                $('.error-message').text($.parseJSON(xhr.responseText).description);
                gred.showPopup('.error-popup');
            }
        });
    });
}

/* Remove Wishlist */
gred.initRemoveWishlist = function () {
    $('.btn-remove-wishlist').click(function (e) {
        e.preventDefault();
        var row = $(this).parents('tr');
        var tagID = row.find('.tag-id').val();
        var form = jQuery('#remove-wishlist-form');
        form.find("input[name='contact[tags]']").val('x' + tagID);
        $.ajax({
            type: 'POST',
            url: '/contact',
            data: form.serialize(),
            beforeSend: function () {
                gred.showPopup('.loading');

            },
            success: function (data) {
                row.fadeOut(500);
                gred.hidePopup('.loading');
            },
            error: function (xhr, text) {
                $('.error-message').text($.parseJSON(xhr.responseText).description);
                gred.showPopup('.error-popup');
            }
        });
    });
}

/* Review */
gred.initReview = function () {
    if ($(".spr-badge").length > 0) {
        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
    }
    ;
}


/* ConvertCurrency */
gred.ConvertCurrency = function () {
    if (gred.reConvertCurrency() && window.show_multiple_currencies) {
        Currency.convertAll(window.shop_currency, jQuery('.currency-picker').val(), 'span.money', 'money_format');
    }
}


$(gred.init)